import { useEffect } from 'react'
import { BRAND_COLORS } from '../../mixtiles-web-common/elements/Theme/photosTheme'

export const DEFAULT_THEME_COLOR = BRAND_COLORS.white

const colorStack: string[] = [DEFAULT_THEME_COLOR]

interface BrowserThemeColorProps {
  color: string
  enabled?: boolean
}

const updateMetaElement = (color: string): void => {
  if (typeof document !== 'undefined') {
    const metaElement = document.querySelector('meta[name="theme-color"]')
    if (metaElement) {
      metaElement.setAttribute('content', color)
    }
  }
}

export default function BrowserThemeColor({
  color,
  enabled = true,
}: BrowserThemeColorProps) {
  useEffect(() => {
    if (!enabled) return

    colorStack.push(color)
    updateMetaElement(color)

    return () => {
      const index = colorStack.lastIndexOf(color)
      if (index > 0) {
        colorStack.splice(index, 1)
      }
      updateMetaElement(colorStack[colorStack.length - 1])
    }
  }, [color, enabled])

  return null
}
